import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppFooterPrivate } from './_Footers/AppFooterPrivate';
import { AppHeaderPrivate } from './_Headers/AppHeaderPrivate';
import { AppSidebarPrivate } from './Sidebars/AppSidebarPrivate';
import { ScrollToTopButton } from './_Utilities/ScrollToTopButton';
import { onApplyLayoutTemplate } from '../_Templates/AppTemplateResolved';
import { useSectionTitle } from '../../../_CORE/Hooks/useSectionMetaTitle';
import { AppHeaderUtilities } from './_Headers/_Utilities/AppHeaderUtilities';
import { userHasAccess } from '../../../_Helpers/Helpers/_moduleFactory.helper.js';
import { useLanguage } from '../../../_CORE/Contexts/Translate/useLanguageContext';
import { APP_LAYOUT_STRUCTURE, onResolveLayoutNavigation } from './AppLayoutStructure';
import { buildPrivateSidebarNavigation } from './Sidebars/PrivateSidebar.navigation.js';
import { APP_ENVIRONMENT } from '../../../_CORE/_RuntimeConfig/_Config/Acomodar/AppEnvironment.js';
import { BannerModeDevelopment } from '../../../_CORE/_RuntimeConfig/_Config/Acomodar/BannerModeDevelopment.js';

export const AppLayoutPrivate = ({ isAuth = true, user = null, onClickLogout = null, outletContext = {} }) => {

    const [useNameAsideOpenState, setNameAsideOpenState] = useState(false);
    const { pathname } = useLocation();
    const { useDataLanguage } = useLanguage();

    const LAYOUT_NAV = onResolveLayoutNavigation(user, useDataLanguage.currentLang);
    const BRAND = { ...APP_LAYOUT_STRUCTURE.brand, claim: LAYOUT_NAV.claim };
    const ACCESSIBLE_PRIVATE_ROUTES = LAYOUT_NAV.privateRoutes.filter((item) => userHasAccess(user, item));
    const SIDEBAR_NAV = buildPrivateSidebarNavigation({ pathname, routes: ACCESSIBLE_PRIVATE_ROUTES });

    useSectionTitle(LAYOUT_NAV.privateRoutes, APP_LAYOUT_STRUCTURE.brand.name);

    useEffect(() => {
        onApplyLayoutTemplate(APP_ENVIRONMENT.TEMPLATES.LAYOUT_STRUCTURE_PRIVATE);
    }, []);

    const onCloseAside = () => setNameAsideOpenState(false);

    return (
        <div className="LStudio__app_layout LStudio__app_layout--private">
            {
                APP_LAYOUT_STRUCTURE.ui.sidebarPrivate && (
                    <AppSidebarPrivate brand={BRAND} navItems={SIDEBAR_NAV}
                        groupLabel={null} isOpen={useNameAsideOpenState} onClose={onCloseAside} />
                )
            }

            <div className="LStudio__app_layout__column">
                {
                    APP_LAYOUT_STRUCTURE.ui.headerPrivate && (
                        <AppHeaderPrivate onToggleAside={() => setNameAsideOpenState(true)} utilities={(
                            <AppHeaderUtilities
                                isAuth={isAuth} user={user} onClickLogout={onClickLogout}
                                profileLinks={LAYOUT_NAV.profileLinks} languages={APP_LAYOUT_STRUCTURE.languages}
                                data={{}} />
                        )}
                        />
                    )
                }

                <BannerModeDevelopment />

                <main className="LStudio__app_layout__main">
                    <div className="LStudio__app_layout__inner">
                        <Outlet context={outletContext} />
                    </div>
                </main>

                {
                    APP_LAYOUT_STRUCTURE.ui.footerPrivate && (
                        <AppFooterPrivate  brand={BRAND} columns={LAYOUT_NAV.footerColumnsPrivate}
                            legal={LAYOUT_NAV.legal}  showBrandLS={APP_LAYOUT_STRUCTURE.showBrandLS}  />
                    )
                }

                <ScrollToTopButton />
            </div>
        </div>
    );
};
